// Vstupní bod frontendu ECOser App: styly, registrace service workeru (PWA), vykreslení aplikace.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { sledovatKlavesnici } from './komponenty/klavesnice';
import { spustSledovaniVerze } from './pwa/nova-verze';
import { predNacistPriStartu } from './sekce/StrankaSekce';
// Písma z balíčků @fontsource (woff2 jdou do buildu a do precache PWA), jen latin + latin-ext (čeština): Inter 400/600/800, Barlow Condensed 600/800.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-ext-400.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-ext-600.css';
import '@fontsource/inter/latin-800.css';
import '@fontsource/inter/latin-ext-800.css';
import '@fontsource/barlow-condensed/latin-600.css';
import '@fontsource/barlow-condensed/latin-ext-600.css';
import '@fontsource/barlow-condensed/latin-800.css';
import '@fontsource/barlow-condensed/latin-ext-800.css';
import './styly/tokeny.css';
import './styly/zaklad.css';

// Všechny styly aplikace jsou v jednom souboru hlavního balíku, i když se kód obrazovek sekcí stahuje až při
// otevření (sekce/StrankaSekce.tsx). Bez toho by si styly sekcí načítaly vlastní soubory až za základem
// (styly/zaklad.css) a v pořadí podle toho, kam uživatel zrovna klikl — pravidla sekcí se stejnou
// specifičností by pak přebíjela základ jinak než dosud a vzhled by závisel na cestě aplikací.
// Vite importy z globu vytáhne na začátek modulu: styly komponent a sekcí jdou abecedně podle cesty, za nimi
// písma, tokeny a základ — základ má při stejné specifičnosti poslední slovo jako vždycky
// (hlídá test/css-poradi.test.ts). Soubor CSS se do JS nekopíruje, jen se načte.
import.meta.glob(['./**/*.css', '!./styly/**'], { eager: true });

// Service worker (PWA) a hlídání nové verze: novou verzi stáhne na pozadí, ale nasadí se až na
// Obnovit v pruhu „Je k dispozici nová verze aplikace.“ — rozpracovaná práce se nesmí ztratit
// (pwa/nova-verze.ts, docs/09 §10).
spustSledovaniVerze();

// Kód obrazovky sekce z adresy (a na Domů cíl přistání) se začne stahovat hned, souběžně s ověřením přihlášení;
// naposledy otevřené sekce, až bude aplikace v klidu (sekce/StrankaSekce.tsx).
predNacistPriStartu();

// Psaní na tabletu a telefonu: s otevřenou klávesnicí přichycené pruhy a panely nepřekrývají pole (komponenty/klavesnice.ts).
sledovatKlavesnici();

const koren = document.getElementById('koren');
if (!koren) {
  throw new Error('Chybí element #koren v index.html.');
}

createRoot(koren).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
